<template>
  <div class="page-view box-card">
    <div class="box-card-content">
      <div class="user-info" v-if="userInfo">
        <div class="user">
          <div class="avatar">
            <img src="" alt="" />
          </div>
          <div class="info">
            <span class="nickname"
              >{{ userInfo.username }}
              <div class="btn kg-btn4" @click="onShow('boxUserName')">
                <I18Lang id="proxymoney103" defaultText="修改" />
              </div>
            </span>
            <span class="user-id">User ID:{{ userInfo.account_id }}</span>
            <!-- <span
              class="info-tag"
              :class="`status${userInfo.auth_status}`"
              @click="
                $router.push({
                  name: userInfo.identity === 0 ? 'userInfo' : 'proxyInfo',
                })
              "
              >{{ showAuthStatus }}</span
            >
            <div class="auth-remark" v-if="userInfo.auth_remark">
              <I18Lang id="public32" defaultText="审核失败" />：{{
                userInfo.auth_remark
              }}
            </div> -->
          </div>
        </div>
      </div>

      <div class="content">
        <div class="left">
          <div class="form-item">
            <div class="form-item-label">
              <I18Lang id="user36" defaultText="交易账号" />
            </div>
            <div class="form-item-value">{{ userInfo.account_no }}</div>
          </div>

          <div class="form-item">
            <div class="form-item-label">
              <I18Lang id="user53" defaultText="注册时间" />
            </div>
            <div class="form-item-value">{{ userInfo.reg_time }}</div>
          </div>

          <div class="form-item">
            <div class="form-item-label">
              <I18Lang id="user54" defaultText="邮箱" />
            </div>
            <div class="form-item-value">
              {{ userInfo.email }}
              <div class="btn kg-btn4" @click="onShow('boxEmail')">
                <I18Lang id="proxymoney103" defaultText="修改" />
              </div>
            </div>
          </div>

          <div class="form-item">
            <div class="form-item-label">
              <I18Lang id="user55" defaultText="登录密码" />
            </div>
            <div class="form-item-value">
              ******
              <div class="btn kg-btn4" @click="onShow('boxPassword')">
                <I18Lang id="proxymoney103" defaultText="修改" />
              </div>
            </div>
          </div>

          <BoxPassword ref="boxPassword" @onUpdata="onUpdata" />
        </div>
        <!-- <div class="right">
          <div class="virtual-currency-info">
            <div class="title">Withdrawal Information</div>

            <div class="item">
              <div class="item-label">Withdrawal Coin Type</div>
              <div class="item-value">xxxx</div>
            </div>
            <div class="item">
              <div class="item-label">Type</div>
              <div class="item-value">xxxxx</div>
            </div>
            <div class="item">
              <div class="item-label">Wallet Address</div>
              <div class="item-value">xxxx</div>
            </div>
            <div class="item">
              <div class="item-label qr-label">wallet address QR code</div>
              <div class="item-value">
                <img src="" alt="" />
              </div>
            </div>
            <div class="btn kg-btn4" @click="onShow('virtualCurrency')">
              <I18Lang id="proxymoney103" defaultText="修改" />
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <BoxCard ref="boxCard" @onUpdata="onUpdata" />
    <UserBank ref="boxBank" @onUpdata="onUpdata" />
    <BoxEmail ref="boxEmail" @onUpdata="onUpdata" />
    <UserName ref="boxUserName" @onUpdata="onUpdata" />
    <DataAuthentication ref="dataAuthentication" @onUpdata="onUpdataCard" />
    <!-- <VirtualCurrency ref="virtualCurrency" @onUpdata="onUpdataCard" /> -->
  </div>
</template>

<script>
import UserName from './components/UserName.vue'
import BoxEmail from './components/BoxEmail.vue'
import BoxPassword from './components/BoxPassword.vue'
import UserBank from './components/UserBank.vue'
import BoxCard from './components/BoxCard.vue'
import DataAuthentication from './components/DataAuthentication.vue'
import VirtualCurrency from './components/VirtualCurrency.vue'
import { mapState } from 'vuex'
import { userAuthStatusText } from '@utils/global'

export default {
  name: 'record',
  data () {
    return {}
  },
  methods: {
    onShow (name) {
      this.$refs[name].showDialog()
    },
    onUpdata () {
      this.$store.dispatch('getUserInfo')
    },
    onUpdataCard () {
      this.onUpdata()
      this.onShow('dataAuthentication')
    }
  },
  computed: {
    showAuthStatus () {
      return userAuthStatusText[this.userInfo.auth_status]
    },
    ...mapState(['userInfo'])
  },
  components: {
    DataAuthentication,
    BoxCard,
    BoxEmail,
    UserName,
    BoxPassword,
    UserBank,
    VirtualCurrency
  }
}
</script>
<style scoped lang="scss">
.page-view {
  padding-top: 50px;
  padding-bottom: 100px;

  .box-card-header {
    width: 936px;
    margin: 0 auto;
    display: flex;
    justify-content: end;

    .kg-btn1 {
      width: 188px;
      margin-right: -6px;
      margin-bottom: 3px;
    }
  }

  .box-card-content {
    background: url("../../../assets/img/user/personal-bg.png") no-repeat center /
      100% 100%;
    width: 936px;
    padding-top: 40px;
    padding-left: 65px;
    padding-right: 40px;
    padding-bottom: 30px;
    margin: 0 auto;

    .user-info {
      padding-bottom: 32px;
      border-bottom: 1px solid rgb(#00ccff, 0.3);

      .user {
        display: flex;

        .avatar {
          background: url("../../../assets/img/avatar-bg.png") no-repeat center /
            100% 100%;
          width: 90px;
          height: 90px;
          flex: 0 0 90px;
          margin-right: 18px;

          img {
          }
        }

        .info {
          flex: 1;

          .nickname {
            font-size: 20px;
            font-weight: bold;
            color: #00cbfa;
            padding-top: 5px;
          }

          .user-id {
            font-size: 16px;
            display: block;
            font-family: Arial;
            font-weight: 400;
            color: #c9c9c9;
          }
        }
      }

      .info-tag {
        font-size: 12px;
        text-align: center;
        line-height: 21px;
        display: block;
        width: 164px;
        height: 21px;
        margin-top: 11px;
        cursor: pointer;
        text-shadow: 0px 0px 5px #c1f3ff;

        &.status1 {
          color: #ffe9f0;
          background: url("../../../assets/img/status-bg1.png") no-repeat center /
            100% 100%;
        }

        &.status0 {
          color: #ffe9f0;
          background: url("../../../assets/img/status-bg1.png") no-repeat center /
            100% 100%;
        }

        &.status2 {
          color: #c1f3ff;
          background: url("../../../assets/img/status-bg2.png") no-repeat center /
            100% 100%;
        }

        &.status3 {
          color: #ffeeb1;
          background: url("../../../assets/img/status-bg3.png") no-repeat center /
            100% 100%;
        }
      }
    }

    .auth-remark {
      color: #fff;
      font-size: 16px;
      margin-top: 5px;
    }

    .content {
      display: flex;
      justify-content: space-between;
      padding-bottom: 50px;

      .left {
        padding-top: 49px;
        padding-left: 10px;
        width: 300px;
        flex: 0 0 300px;
      }

      .right {
        padding-top: 49px;
        width: 380px;
        flex: 0 0 380px;
        margin-right: 50px;

        .bank-title {
          font-size: 16px;
          font-weight: 400;
          color: #00ccff;
          margin-bottom: 32px;
        }

        .group-img {
          display: flex;
          margin-bottom: 20px;
          justify-content: space-between;

          .card-img {
            &:first-child {
              margin-right: 20px;
            }
          }
        }

        .card-img {
          width: 174px;
          height: 110px;
          flex: 0 0 174px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }

      .virtual-currency-info {
        width: 100%;
        height: 420px;
        background: url("../../../assets/img/bg/virtual-currency-bg.png")
          no-repeat top / 100% 100%;
        .title {
          font-size: 18px;
          color: #fff;
          padding-top: 5px;
          padding-left: 13px;
          margin-bottom: 30px;
        }
        .item {
          margin-bottom: 8px;
          margin-left: 15px;
          &-label {
            font-weight: 400;
            font-size: 14px;
            color: #01b2f5;
          }
          &-value {
            font-size: 16px;
            color: #fff;
          }
          img{
            width: 100px;
            height: 100px;
          }
        }
        .btn{
          margin-left: 8px;
        }
      }

      .bank-info {
        position: relative;

        .bank-info-title {
          font-size: 16px;
          font-weight: 400;
          color: #00ccff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 19px;
        }

        .bank-info-view {
          display: flex;
          justify-content: space-between;

          .bank-info-group {
            width: 174px;
            height: 110px;
            flex: 0 0 174px;
          }

          .info-item {
            margin-bottom: 20px;
          }

          .key {
            font-size: 14px;
            color: #01b2f5;
            line-height: 18px;
          }

          .value {
            font-size: 16px;
            color: #ffffff;
          }
        }
      }

      .form-item {
        margin-bottom: 35px;
        position: relative;

        .form-item-label {
          font-size: 16px;
          color: #00ccff;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .form-item-value {
          font-size: 16px;
          color: #ffffff;
          width: 300px;
          word-break: break-all;
          padding-right: 100px;

          .btn {
            position: absolute;
            left: 200px;
            top: 0;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 755px) {
  .page-view {
    padding-top: 50px;
    padding-bottom: 100px;

    .box-card-header {
      width: 936px;
      margin: 0 auto;
      display: flex;
      justify-content: end;

      .kg-btn1 {
        width: 188px;
        margin-right: -6px;
        margin-bottom: 3px;
      }
    }

    .box-card-content {
      background: none;
      width: auto;
      padding-top: 0;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
      margin: 0 auto;

      .user-info {
        padding-bottom: 32px;
        border-bottom: 1px solid rgb(#00ccff, 0.3);

        .user {
          display: flex;

          .avatar {
            background: url("../../../assets/img/avatar-bg.png") no-repeat
              center / 100% 100%;
            width: 90px;
            height: 90px;
            flex: 0 0 90px;
            margin-right: 18px;

            img {
            }
          }

          .info {
            flex: 1;

            .nickname {
              font-size: 20px;
              font-weight: bold;
              color: #00cbfa;
              padding-top: 5px;
            }

            .user-id {
              font-size: 20px;
              display: block;
              font-family: Arial;
              font-weight: 400;
              color: #c9c9c9;
            }
          }
        }

        .info-tag {
          font-size: 20px;
          text-align: center;
          line-height: 21px;
          display: block;
          width: 204px;
          height: 31px;
          line-height: 31px;
          margin-top: 11px;
          cursor: pointer;
          text-shadow: 0px 0px 5px #c1f3ff;

          &.status1 {
            color: #ffe9f0;
            background: url("../../../assets/img/status-bg1.png") no-repeat
              center / 100% 100%;
          }

          &.status0 {
            color: #ffe9f0;
            background: url("../../../assets/img/status-bg1.png") no-repeat
              center / 100% 100%;
          }

          &.status2 {
            color: #c1f3ff;
            background: url("../../../assets/img/status-bg2.png") no-repeat
              center / 100% 100%;
          }

          &.status3 {
            color: #ffeeb1;
            background: url("../../../assets/img/status-bg3.png") no-repeat
              center / 100% 100%;
          }
        }
      }

      .auth-remark {
        color: #fff;
        font-size: 16px;
        margin-top: 5px;
      }

      .content {
        display: block;
        padding-bottom: 50px;

        .left {
          padding-top: 49px;
          padding-left: 10px;
          width: 100%;
        }

        .right {
          padding-top: 49px;
          width: 100%;
          flex: 0 0 380px;
          margin-right: 50px;

          .bank-title {
            font-size: 20px;
            font-weight: 400;
            color: #00ccff;
            margin-bottom: 32px;
          }

          .group-img {
            display: flex;
            margin-bottom: 20px;
            justify-content: space-between;

            .card-img {
              &:first-child {
                margin-right: 20px;
              }
            }
          }

          .card-img {
            width: 174px;
            height: 110px;
            flex: 0 0 174px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }

        .bank-info {
          position: relative;

          .bank-info-title {
            font-size: 20px;
            font-weight: 400;
            color: #00ccff;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 19px;
          }

          .bank-info-view {
            display: flex;
            justify-content: space-between;

            .bank-info-group {
              width: 174px;
              height: 110px;
              flex: 0 0 174px;
            }

            .info-item {
              margin-bottom: 20px;
            }

            .key {
              font-size: 20px;
              color: #01b2f5;
              line-height: 18px;
            }

            .value {
              font-size: 20px;
              color: #ffffff;
            }
          }
        }

        .form-item {
          margin-bottom: 35px;
          position: relative;

          .form-item-label {
            font-size: 20px;
            color: #00ccff;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .form-item-value {
            font-size: 20px;
            color: #ffffff;
            width: 200px;
            word-break: break-all;

            .btn {
              position: absolute;
              left: auto;
              right: 0;
              top: 0;
            }
          }
        }
      }
    }
  }
}
</style>
